/**
 * Created by Owner on 2016/7/26.
 */
import {App, LoadingController} from 'ionic-angular';
import {Injectable} from '@angular/core';
import {Http, Response, Headers} from '@angular/http';
import {Observable} from "rxjs/Rx";
import * as helper from '../directives/helpers';
import {AppDialog} from "../component/appDialog";
import {LoginPage} from "../pages/login/login";

import { CommonService } from "./common.service";

@Injectable()
export class AppConfigService {

    USER_SERVICE = 'UserService.aspx';
    LOTTERY_SERVICE = 'LotteryService.aspx';
    MOBILE_SERVICE = 'MobileService.aspx';
    SIXMARK_SERVICE = 'MarkSixService.aspx';
    TAIXIU1GIAY_SERVICE = 'GameService.aspx';
    TAIXIU1PHUT_SERVICE = 'K31fGameService.aspx';
    XOCDIA_SERVICE = 'XDService.aspx';
    BAUCUA_SERVICE = 'BCService.aspx';
    OANTUTI_SERVICE = 'OanTuTiService.aspx';
    GA_SERVICE = 'GaService.aspx';

    static sid: any = "";

    constructor(private app: App, private http: Http, public cs: CommonService) {

    }

    getUserService(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }

    getLotteryService(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.LOTTERY_SERVICE);
    }

    getDualNumber(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.LOTTERY_SERVICE);
    }

    getMobileService(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.MOBILE_SERVICE);
    }

    getSixMarkService(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.SIXMARK_SERVICE);
    }

    getTaiXiu(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.TAIXIU1GIAY_SERVICE);
    }

    getTaiXiuInit(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }

    getTaiXiu1PhutInit(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.TAIXIU1PHUT_SERVICE);
    }

    auditUser(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }

    requestHttp(data, comp: any, url: string) {
        let alertCtrl: any;
        let loadingCtrl: LoadingController;
        let loading: any;
        if (window["serveApi"]) {
            url = window["serveApi"] + url;
        }
        if (comp != null && comp != undefined && comp["alertCtrl"]) {
            alertCtrl = comp["alertCtrl"];
            loadingCtrl = comp["loadingCtrl"];
            loading = loadingCtrl.create({
                content: ''
            });
            loading.present();
        }
        let me = this;
        let promise = new Promise((resolve, reject) => {
            let body = helper.toBodyString(data);
            let headers = new Headers();
            if (AppConfigService.sid != "") {
                //     url += ";jsessionid=" + AppConfigService.sid;
            }
            headers.append('Content-Type', 'application/x-www-form-urlencoded');
            me.http.post(url, body, {headers: headers}).timeout(15000).map(res => {
                let serveData: any = null;
                try {
                    serveData = res.json();
                }
                catch (e) {
                    AppDialog.alert({
                        message: "Có lỗi xảy ra. Vui lòng liên hệ CSKH! </br> Cảm ơn bạn.",
                        alertCtrl: alertCtrl,
                        callBack: () => {
                            this.app.getRootNav().setRoot(LoginPage);
                            this.cs.userType = 0; // to hide top header 'Bạn đăng ở tài khoản chơi thử'
                        }
                    });
                }
                if (loading) {
                    setTimeout(() => {
                        loading.dismiss().catch(() => {});
                    }, 800);
                }
                //if (serveData.hasOwnProperty("msg") && serveData.msg == "请重新登录") {
                if (serveData.hasOwnProperty("errorCode") && serveData.errorCode === -1) {
                    this.app.getRootNav().setRoot(LoginPage);
                    this.cs.userType = 0; // to hide top header 'Bạn đăng ở tài khoản chơi thử'
                     throw new Error("Login Required"); // Throw để dừng xử lý tiếp theo
                }
                resolve(serveData);
            }).catch(me.handleError).subscribe(data => {
                if (loading) {
                    loading.dismiss().catch(() => {});
                }
                reject(data);
            }, err => {
                console.log(err);
                if (loading) {
                    loading.dismiss().catch(() => {});
                }
                if (alertCtrl != null) {
                    setTimeout(() => {
                        AppDialog.alert({
                            message: 'Lỗi kết nối',
                            alertCtrl: alertCtrl,
                            callBack: () => {
                                this.app.getRootNav().setRoot(LoginPage);
                                this.cs.userType = 0; // to hide top header 'Bạn đăng ở tài khoản chơi thử'
                            }
                        });
                    }, 2000);
                }
            });
        });
        return promise;
    }

    private handleError(error: Response) {
        return Observable.throw(
            error.json().error || 'Server Error'
        );
    }

    // API IBC
    getSSLoginIBC(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }

    getBalanceIBC(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }

    transferBalanceIBC(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }
    // END API IBC


    // API HABA
    getHabaLogin(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }
    getHabaBalance(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }
    getHabaTransferBalance(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }
    // END API HABA


    // API EBET
    getEbetLogin(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }
    getEbetUserInfor(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }
    getEbetTransferBalance(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }
    // END API EBET


    // API EVENTS
    initEvent(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }
    getHistoryUser(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }
    getUserOpenGift(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }
    // END API EVENTS

    // API XOCDIA
    initXocdia1s(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.XOCDIA_SERVICE);
    }
    xocdiaBet1s(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.XOCDIA_SERVICE);
    }
    initXocdia1m(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.XOCDIA_SERVICE);
    }
    xocdiaBet1m(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.XOCDIA_SERVICE);
    }
    xocdiaHistoryTop(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.XOCDIA_SERVICE);
    }
    xocdia1mBetOpen(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.XOCDIA_SERVICE);
    }
    // END API XOCDIA


    // API BANCA
    getListGameBanCa(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }
    getBalanceBanCa(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }
    getForwardLinkBanCa(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }
    funtransferBanCa(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.USER_SERVICE);
    }
    // END API BANCA


    // API BAUCUA
    initBC1s(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.BAUCUA_SERVICE);
    }
    getBalanceMain(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.LOTTERY_SERVICE);
    }
    bettingBC1s(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.BAUCUA_SERVICE);
    }
    initBC1m(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.BAUCUA_SERVICE);
    }
    getHistoryIssues(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.BAUCUA_SERVICE);
    }
    getCurIssueNext(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.BAUCUA_SERVICE);
    }
    getOpenWin(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.BAUCUA_SERVICE);
    }
    bettingBC1M(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.BAUCUA_SERVICE);
    }
    // END API BAUCUA

    // API OANTUTI
    init1s(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.OANTUTI_SERVICE);
    }
    bettingOantuti(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.OANTUTI_SERVICE);
    }
    // END API OANTUTI

     //API THIRDPARTY GAME
     gameThirdParty(data, alertCtrl: any) {
        return this.requestHttp(data, alertCtrl, this.GA_SERVICE);
    }   

}



// WEBPACK FOOTER //
// ./src/services/appConfig.service.ts